"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SidebarMenuItem = _interopRequireDefault(require("./SidebarMenuItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _SidebarMenuItem.default;
exports.default = _default;